import { FiAirplay, FiUsers, FiPhone, FiLayers, FiSettings, FiFileText, FiServer, FiCalendar, FiVolume, FiList, } from "react-icons/fi";

import { IoAccessibilityOutline } from "react-icons/io5";


export const MENU_CONFIG = [
    {
        id: 1,
        label: "Dashboards",
        path: "/dashboard",
        icon: FiAirplay,
    },

    {
        id: 2,
        label: "User Management",
        path: "/user/list",
        icon: FiUsers,
    },

    {
        id: 3,
        label: "Roles & Permission",
        path: "/roles",
        icon: IoAccessibilityOutline,
    },

    {
        id: 4,
        label: "Call logs",
        path: "/callLogs",
        icon: FiPhone,
    },

    {
        id: 5,
        label: "Knowledge Base",
        path: "/knowledgeBase",
        icon: FiFileText,
    },

    {
        id: 6,
        label: "QA Management",
        icon: FiLayers,
        children: [
            {
                label: "QA - Section",
                path: "/qaSection",
            },
            {
                label: "QA - Question",
                path: "/qaQuestion",
            },
        ],
    },

    {
        id: 7,
        label: "Configuration",
        icon: FiLayers,
        children: [
            {
                label: "Category Management",
                path: "/category",
            },
            {
                label: "Dropdown Management",
                path: "/dropdown",
            },
        ],
    },

    {
        id: 8,
        label: "System Management",
        path: "/callStatus",
        icon: FiServer,
    },

    {
        id: 9,
        label: "Shift Management",
        path: "/shiftManagement",
        icon: FiCalendar,
    },

    {
        id: 10,
        label: "Queue Management",
        path: "/queue",
        icon: FiList,
    },

    {
        id: 11,
        label: "Campaigns",
        icon: FiVolume,
        children: [
            {
                label: "Campaign List",
                path: "/campaign/campaign-list",
            },
            {
                label: "Agent Assignment",
                path: "/campaign/agent-assignment",
            }
        ],
    },

    {
        id: 12,
        label: "Site Settings",
        path: "/settings/general",
        icon: FiSettings,
    },
];